import { render, staticRenderFns } from "./sendList.vue?vue&type=template&id=55e59416&"
import script from "./sendList.vue?vue&type=script&lang=js&"
export * from "./sendList.vue?vue&type=script&lang=js&"
import style0 from "./sendList.vue?vue&type=style&index=0&id=55e59416&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports